import React from "react";
import { ArrowRight, Flower2, HandHeart, Sun } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Clinical Massage",
  description: "Deeply restorative techniques tailored to release chronic tension and restore structural alignment within our tranquil Brooke sanctuary.",
  icon: HandHeart
}, {
  title: "Aesthetic Facials",
  description: "Advanced skin rejuvenation that blends clinical precision with high-end luxury to unveil your most radiant, healthy complexion.",
  icon: Flower2
}, {
  title: "Beauty",
  description: "Our advanced treatments are designed to deliver real, visible results while still providing a relaxing and comfortable experience.",
  icon: Sun
}];
export default function CuratedHealingModalities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="25627" id="restorative-therapies" className="relative w-full py-24 bg-background overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-lg bg-primary/10 blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] rounded-lg bg-secondary/30 blur-[120px]" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div ref={ref} className={cn("flex flex-col items-center gap-16 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <div className="text-center max-w-2xl mx-auto space-y-4">
            <h2 className="text-4xl md:text-6xl font-serif font-light text-foreground tracking-widest">
              Restorative Therapies
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed font-sans italic">
              Experience the pinnacle of clinical excellence and quiet luxury at Natalia's Beauty, where every treatment is a bespoke journey toward rejuvenation.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
            {services.map((service, i) => <div key={i} data-index={i} className="group relative flex flex-col items-start gap-6 p-8 border border-border/20 bg-card/40 backdrop-blur-xl shadow-sm transition-all duration-700 hover:scale-[1.02] hover:shadow-xl hover:bg-white/60 dark:hover:bg-white/10">
                <div className="p-4 rounded-lg bg-secondary/50 dark:bg-white/5 border border-border/10 transition-colors duration-500 group-hover:border-ring/40">
                  <service.icon strokeWidth={1} className="w-10 h-10 text-foreground transition-colors duration-500 group-hover:text-ring" />
                </div>
                
                <div className="space-y-3">
                  <h3 className="text-2xl font-serif font-medium text-foreground group-hover:text-ring transition-colors duration-500">
                    {service.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed font-sans text-sm tracking-wide">
                    {service.description}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="pt-4">
            <Button asChild variant="link" className="text-sm uppercase tracking-widest font-semibold text-foreground hover:text-ring transition-colors group p-0 h-auto">
              <Link to="https://nataliasbeauty.com/beauty-treatments-norwich/" newTab className="flex items-center gap-2">
                View Treatment Menu
                <ArrowRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-2" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}